module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_1.eda08b9e.png";